import { Link, useParams } from "react-router-dom";
import Header from "../../components/layout/Header";
import Sidebar from "../../components/layout/Sidebar";
import TransactionTimeline from "../../components/dealer/transacton/TransactionTimeline";

const TransactionHistory = ({ nav }) => {
  const { id } = useParams();

  return (
    <>
      <div className={nav.isSidebar}>
        <Header nav={nav} />
        <Sidebar nav={nav} />
        {/*start content*/}
        <main className="page-content">
          {/*breadcrumb*/}
          <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
            <div className="breadcrumb-title pe-3">Dealer Account View</div>
            <div className="ps-3">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-0 p-0">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <i className="bx bx-home-alt" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/dealer/list-dealer">List All Dealers</Link>
                  </li>
                  <li className="breadcrumb-item " aria-current="page">
                    <Link to={`/dealer/view-dealer/${id}`}>
                      Dealer Overview
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Transaction History
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          {/*end breadcrumb*/}
          <TransactionTimeline id={id} />
          {/*end row*/}
        </main>

        <div className="overlay nav-toggle-icon" />
        <a href="" className="back-to-top">
          <i className="bx bxs-up-arrow-alt" />
        </a>
      </div>
    </>
  );
};

export default TransactionHistory;
